// extracted by mini-css-extract-plugin
export default {"timeOverlay":"kZmiWu","overlay":"zpirtB","overlay--wide":"NRZ70J"};